/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttachmentsItem } from '../../models/attachments-item';
import { BaseResponse } from '../../models/base-response';

export interface AttachmentsControllerFindOne$Params {
  id: number;
}

export function attachmentsControllerFindOne(http: HttpClient, rootUrl: string, params: AttachmentsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AttachmentsItem;
}>> {
  const rb = new RequestBuilder(rootUrl, attachmentsControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AttachmentsItem;
      }>;
    })
  );
}

attachmentsControllerFindOne.PATH = '/attachments/{id}';
